import { render, staticRenderFns } from "./PlaceTab.vue?vue&type=template&id=6990d34b&"
import script from "./PlaceTab.vue?vue&type=script&lang=ts&"
export * from "./PlaceTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports